/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Kod',
    COUNTERPARTS: 'Odpowiedniki',
    CURRENT: 'Aktualny',
    GENERAL_INFORMATION: 'Informacje ogólne',
    MANAGER: 'Kierownik',
    PREVIOUS: 'Poprzedni',
    PRODUCTS: 'Produkty',
    REMUNERATION: 'Wynagrodzenie',
    SUPERVISOR: 'Nadzorca'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
